module.exports = __webpack_public_path__ + "assets/c8d4ab290f0e0a194a00b26280e070d8.png";